import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { BlogPost } from "@/lib/blog/posts";

interface BlogCardProps {
  post: BlogPost;
}

export function BlogCard({ post }: BlogCardProps) {
  return (
    <article className="group flex flex-col h-full rounded-2xl border border-border bg-card p-6 shadow-soft hover:border-[rgb(var(--green))] transition-colors">
      <p className="eyebrow mb-3">
        {post.category} · {post.readTime} min
      </p>
      <h2 className="font-display text-xl md:text-2xl font-extrabold leading-snug tracking-tight mb-3">
        <Link
          href={`/blog/${post.slug}`}
          className="text-foreground group-hover:text-[rgb(var(--green-deep))] transition-colors"
        >
          {post.title}
        </Link>
      </h2>
      <p className="text-sm text-foreground/75 leading-relaxed line-clamp-3 mb-4 font-medium flex-1">
        {post.description}
      </p>
      <Link
        href={`/blog/${post.slug}`}
        className="inline-flex items-center gap-1.5 text-sm font-bold text-[rgb(var(--green-deep))] hover:gap-2 transition-all"
      >
        Ler artigo
        <ArrowRight className="w-4 h-4" />
      </Link>
    </article>
  );
}
